import { C } from "./colors";

export const lightPalette = {
  mode: "light" as const,
  primary: { main: C.ink, dark: "#000000", light: "#2A2A2A", contrastText: "#FFFFFF" },
  secondary: { main: C.coral, dark: C.coralText, light: C.bone, contrastText: C.ink },
  success: { main: C.leaf, dark: "#2F5E42", light: C.leafTint, contrastText: "#FFFFFF" },
  warning: { main: C.coralText, dark: "#8A2B0C", light: C.bone, contrastText: "#FFFFFF" },
  error: { main: C.danger, dark: "#5A0014", light: C.dangerTint, contrastText: "#FFFFFF" },
  info: { main: C.moss, dark: "#14291D", light: C.leafTint, contrastText: "#FFFFFF" },
  background: { default: C.ground, paper: C.paper },
  text: { primary: C.ink, secondary: C.ink2, disabled: C.faint },
  divider: C.line,
  action: { hover: "rgba(14,14,14,0.04)", selected: "rgba(14,14,14,0.07)", focus: "rgba(14,14,14,0.12)" },
};
